import { apiClient } from '@/lib/api/client';
// ─── API client ─────────────────────────────────────────────────────────────
export const tourscanApi = {
    /** POST /api/v1/tourscan/sessions */
    async startSession(dto) {
        const { data } = await apiClient.post('/api/v1/tourscan/sessions', dto);
        return data;
    },
    /** GET /api/v1/tourscan/sessions?groupId=&isOpen= */
    async listSessions(params) {
        const { data } = await apiClient.get('/api/v1/tourscan/sessions', { params });
        return data.data;
    },
    /** GET /api/v1/tourscan/sessions/:id */
    async getSession(id) {
        const { data } = await apiClient.get(`/api/v1/tourscan/sessions/${id}`);
        return data;
    },
    /** PATCH /api/v1/tourscan/sessions/:id/close */
    async closeSession(id) {
        const { data } = await apiClient.patch(`/api/v1/tourscan/sessions/${id}/close`);
        return data;
    },
    async reopenSession(id) {
        const { data } = await apiClient.patch(`/api/v1/tourscan/sessions/${id}/reopen`);
        return data;
    },
    /** GET /api/v1/tourscan/sessions/:id/report */
    async getSessionReport(id) {
        const { data } = await apiClient.get(`/api/v1/tourscan/sessions/${id}/report`);
        return data;
    },
    /** POST /api/v1/tourscan/attendances */
    async recordAttendance(dto) {
        const { data } = await apiClient.post('/api/v1/tourscan/attendances', dto);
        return data;
    },
    /** GET /api/v1/tourscan/sessions/:id/report — returns attendances with passenger info */
    async listSessionAttendances(id) {
        const { data } = await apiClient.get(`/api/v1/tourscan/sessions/${id}/report`);
        return data;
    },
    /** PATCH /api/v1/tourscan/attendances/:id — update attendance status (manual confirm) */
    async updateAttendance(id, status, notes) {
        const { data } = await apiClient.patch(`/api/v1/tourscan/attendances/${id}`, { status, notes });
        return data;
    },
    /** DELETE /api/v1/tourscan/attendances/:id — undo a scan within 60s */
    async deleteAttendance(id) {
        await apiClient.delete(`/api/v1/tourscan/attendances/${id}`);
    },
    /** POST /api/v1/tourscan/attendances/manual — manually confirm passenger */
    async manualConfirm(sessionId, passengerId, status) {
        const { data } = await apiClient.post('/api/v1/tourscan/attendances/manual', {
            sessionId,
            passengerId,
            status,
        });
        return data;
    },
    /** POST /api/v1/tourscan/sessions/:id/reset — clear all attendances */
    async resetSession(id) {
        const { data } = await apiClient.post(`/api/v1/tourscan/sessions/${id}/reset`, { confirm: true });
        return data;
    },
};
//# sourceMappingURL=tourscan.js.map